import { defineComponent as a, openBlock as o, createElementBlock as n, createVNode as i, unref as l, createElementVNode as e, toDisplayString as _ } from "vue";
import { CloseCircleFillIcon as c } from "@frontiers/brink-icons";
import './assets/index28.css';const r = { class: "ValidationMessage" }, d = /* @__PURE__ */ e("span", null, null, -1), p = { class: "ValidationMessage__text" }, V = /* @__PURE__ */ a({
  __name: "ValidationMessage",
  props: {
    message: { default: "" }
  },
  setup(s) {
    const t = s;
    return (m, g) => (o(), n("div", r, [
      i(l(c), {
        size: "sm",
        fill: "var(--red50)"
      }),
      d,
      e("p", p, _(t.message), 1)
    ]));
  }
});
export {
  V as ValidationMessage
};
